import {POST} from '../modules/fetch.ts';
import {resolveConversation} from '../modules/resolve-conversation.ts';

customElements.define('reaction-selector', class ReactionSelector extends HTMLElement {
  clickHandler: (e: Event) => Promise<void>;

  connectedCallback() {
    this.clickHandler = async (e) => {
      const target = (this as Element);
      e.preventDefault();

      if (!target) return;

      if (target.classList.contains('disabled')) return;

      const actionUrl = target.closest('[data-action-url]').getAttribute('data-action-url');
      const reactionContent = target.getAttribute('data-reaction-content');

      // Smart Review feedback buttons live outside .comment-container.
      // After toggling the reaction, update the conversation holder to
      // reflect the resolve/unresolve state.
      const feedbackContainer = target.closest('.smart-review-feedback') as HTMLElement;
      if (feedbackContainer) {
        const hasReacted = target.getAttribute('data-has-reacted') === 'true';
        await POST(`${actionUrl}/${hasReacted ? 'unreact' : 'react'}`, {
          data: new URLSearchParams({content: reactionContent}),
        });

        // Toggle the button's visual state locally.
        target.setAttribute('data-has-reacted', String(!hasReacted));
        target.classList.toggle('primary');
        let countEl = target.querySelector('.reaction-count');
        const newCount = (countEl ? parseInt(countEl.textContent, 10) : 0) + (hasReacted ? -1 : 1);
        if (newCount > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'reaction-count';
            target.append(countEl);
          }
          countEl.textContent = String(newCount);
        } else if (countEl) {
          countEl.remove();
        }

        // For thumbs-down, the server auto-resolves/unresolves the
        // conversation. Refresh the conversation holder using data from
        // the feedback container.
        if (reactionContent === '-1') {
          const conversationHolder = feedbackContainer.closest('.conversation-holder') ||
            feedbackContainer.closest('.timeline-item')?.querySelector('.conversation-holder');
          if (conversationHolder) {
            await resolveConversation({
              url: feedbackContainer.getAttribute('data-resolve-url'),
              commentId: feedbackContainer.getAttribute('data-comment-id'),
              origin: feedbackContainer.getAttribute('data-origin'),
              action: hasReacted ? 'UnResolve' : 'Resolve',
              conversationHolder,
            });
          }
        }

        return;
      }

      const commentContainer = target.closest('.comment-container');

      const bottomReactions = commentContainer.querySelector('.bottom-reactions'); // may not exist if there is no reaction
      const bottomReactionBtn = bottomReactions?.querySelector(`[data-reaction-content="${CSS.escape(reactionContent)}"]`);
      const hasReacted = bottomReactionBtn?.getAttribute('data-has-reacted') === 'true';

      const res = await POST(`${actionUrl}/${hasReacted ? 'unreact' : 'react'}`, {
        data: new URLSearchParams({content: reactionContent}),
      });

      const data = await res.json();

      bottomReactions?.remove();
      if (data.html) {
        commentContainer.insertAdjacentHTML('beforeend', data.html);
      }
    };

    this.addEventListener('click', this.clickHandler);
  }

  disconnectedCallback() {
    if (this.clickHandler) {
      this.removeEventListener('click', this.clickHandler);
    }
  }
});
